export default {
    data() {
        return {
            windowWidth: 1920
        };
    },
    computed: {
        isUnderOrEqualViewport1872() {
            return this.windowWidth <= 1872 ? true : false;
        },
        isUnderOrEqualViewport1440() {
            return this.windowWidth <= 1440 ? true : false;
        },
        isUnderOrEqualViewport1360() {
            return this.windowWidth <= 1360 ? true : false;
        },
        isUnderOrEqualViewport1024() {
            return this.windowWidth <= 1024 ? true : false;
        },
        isUnderOrEqualViewport991() {
            return this.windowWidth <= 991 ? true : false;
        },
        isUnderOrEqualViewport768() {
            return this.windowWidth <= 768 ? true : false;
        }
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        }
    },
    mounted() {
        this.windowWidth = window.innerWidth;
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    }
};
